import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/[locale]/signin/page.tsx");
